import { useEffect, useState } from 'react';
import { fetchInteriorHealth } from '../api';
import type { InteriorHealth } from '../types';

const POLL_INTERVAL_MS = 5000;

/**
 * Hook for the interior service's `/health` endpoint.
 *
 * Mirrors the lightning `useHealth` and video `useVideoHealth` shapes
 * so `AppShell` can normalise all three into the same
 * `SystemStatusCounts` shape regardless of which mini-app is active.
 */
export function useInteriorHealth() {
  const [health, setHealth] = useState<InteriorHealth | null>(null);
  const [beLive, setBeLive] = useState(false);

  useEffect(() => {
    let cancelled = false;
    const tick = async () => {
      try {
        const data = await fetchInteriorHealth();
        if (cancelled) return;
        setHealth(data);
        setBeLive(true);
      } catch {
        if (cancelled) return;
        setBeLive(false);
      }
    };
    tick();
    const id = window.setInterval(tick, POLL_INTERVAL_MS);
    return () => {
      cancelled = true;
      window.clearInterval(id);
    };
  }, []);

  return { health, beLive };
}
